import React from 'react';

import Navigationbar  from './Navigationbar';
import BuildingsManager  from './Buildings';
import { useAuth} from "../authprovider";
import ControllRoom from "./control/Controll";

export default function  Main()  {

    const auth = useAuth();


    return (

        <>
            {auth.user.isAdmin &&
                <>
                    <Navigationbar/>
                    <BuildingsManager/>
                </>
            }
            {((auth.user.isManager || auth.user.isSteward) && auth.user.hasBuilding) &&
                <ControllRoom/>
            }
        </>


    );
}



// function ManagerRooms({buildings}){
//
//     const auth = useAuth();
//     const [activeBuilding, setActiveBuilding] = useState(buildings[0]);
//     const [buildingNames, setBuildingNames] = useState(undefined)
//
//     const isActive = (id)=> id === activeBuilding ? "active" : "";
//
//     const setActive = (building_id)=>setActiveBuilding(building_id)
//
//     useEffect(()=>{
//         if(buildingNames === undefined)
//             auth.buildings.get(({success, content})=>{
//                 if(!success) return
//
//
//                  setBuildingNames(content.filter(c=>buildings.indexOf(c.id)>-1 ).map(b=> {
//                      return {id: b.id, name: b.name}
//                  }))
//             })
//     })
//
//       return(
//           <>
//
//               <Nav className={"position-relative"} variant="tabs" defaultActiveKey={""}>
//                   {
//                       buildingNames && buildingNames.map(b=>
//                           <Nav.Item key={b.id}>
//                               <a
//                                   className={`nav-link ${isActive(b.id)}`} onClick={()=>setActive(b.id)} >{b.name}</a>
//                           </Nav.Item>
//                       )
//                   }
//               </Nav>
//               <ControllRoom building={activeBuilding}/>
//           </>
//       )
//
//
// }